"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXs, SpaceMd, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const HeaderContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
`;
const HeadingWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "level" && prop !== "hasTitleOrIcon"
})(({
  level,
  hasTitleOrIcon
}) => {
  const isSubLevel = level !== void 0 && level > 0;
  return !hasTitleOrIcon ? {
    position: "absolute",
    top: "0",
    right: "0",
    padding: SpaceXs,
    justifyContent: "flex-end"
  } : {
    display: "flex",
    padding: isSubLevel ? SpaceXs : `${SpaceXs} ${SpaceXs} ${SpaceXs} ${SpaceMd}`,
    alignItems: "flex-start",
    gap: isSubLevel ? "0" : SpaceXs,
    alignSelf: "stretch"
  };
});
const TitleAndIconWrapper = styled(Box)`
    display: flex;
    padding-top: 6px;
    align-items: flex-start;
    gap: ${SpaceXxs};
    flex: 1 0 0;
`;
const IconWrapper = styled(Box)`
    display: flex;
    padding-top: 2px;
    align-items: center;
    gap: ${SpaceXs};
`;
const ChildrenWrapper = styled(Box)`
    display: flex;
    padding: 0px ${SpaceMd} ${SpaceMd} ${SpaceMd};
    flex-direction: column;
    align-items: flex-start;
    gap: ${SpaceXs};
    align-self: stretch;
`;
export {
  ChildrenWrapper,
  HeaderContainer,
  HeadingWrapper,
  IconWrapper,
  TitleAndIconWrapper
};
